<div class="wrapper flex flex-col justify-between">
  <div class="heading-row flex justify-between items-center mb-[40px]">
    <div class="heading text-type-2">
      @if (data?.uuid || record?.uuid) {
        {{ data?.name || record?.name || 'Sample' }}
        @if (embeddedContext) {
          <span class="text-type-11"> (Acceptance Record)</span>
        }
      } @else {
        {{ embeddedContext ? 'Create acceptance record' : 'Create sample record' }}
      }
    </div>
  </div>

  @if (loading) {
    <div class="loading-state mb-[24px]">Loading sample&hellip;</div>
  }

  @if (!groupConfigs?.length && !loading) {
    <div class="empty-config text-type-8">
      Sample record form is not configured for this organization. Please run the
      sample-record form config SQL for this org.
    </div>
  }

  <input
    #fileInput
    type="file"
    multiple
    accept="image/*,application/pdf"
    class="hidden-file-input"
    (change)="onFileSelected($event)"
  />

  <div class="details flex-1">
    @if (data?.uuid || record?.uuid) {
      <div class="row-details flex flex-col gap-[12px] mb-[40px]">
        <div class="label w-full uppercase">Status:</div>
        <div class="value w-full text-type-11">
          <div
            [ngClass]="isPushed() ? ['bg-approved', 'txt-approved'] : ['bg-draft', 'txt-draft']"
            class="status-chip px-[14px] rounded-full"
            data-testid="sample-status-chip"
            >
            {{ isPushed() ? 'Pushed to AASHTOWare' : 'Not pushed' }}
          </div>
        </div>
        @if (readOnly) {
          <div class="hint-text text-type-14" data-testid="sample-readonly-hint">
            Read-only on the web. Samples are collected and edited in the mobile app.
          </div>
        }
      </div>
    }

    @for (group of groupConfigs; track group.key) {
      <div class="group-accordion" [class.is-expanded]="isGroupExpanded(group.key)">
        <div (click)="toggleGroup(group.key)" class="group-header flex justify-between items-center cursor-pointer">
          <div class="group-title text-type-3">{{ group.label | sentenceCase }}</div>
          <mat-icon
            [svgIcon]="isGroupExpanded(group.key) ? 'chevron-up' : 'chevron-down'"
            class="chevron-icon"
          />
        </div>
        <div class="group-content">

        @if (group?.ui_config?.repeating) {
          <div class="repeating-rows">
            @if (!rows[group.key]?.length) {
              <div class="empty-rows text-type-14 mb-[10px]">No entries yet.</div>
            }
            @for (row of rows[group.key]; track row; let i = $index) {
              <div class="row-card mb-[12px] p-[12px]">
                <div class="row-header flex justify-between items-center mb-[8px]">
                  <div class="row-label text-type-11">#{{ i + 1 }}</div>
                  @if (!readOnly) {
                    <button mat-icon-button (click)="removeRow(group.key, i)" aria-label="Remove">
                      <mat-icon svgIcon="trash"></mat-icon>
                    </button>
                  }
                </div>

                @for (field of group.fields; track trackByName(0, field)) {
                  @if (readOnly) {
                    <app-view-field
                      [attr.data-testid]="'sample-value-' + group.key + '-' + i + '-' + field.name"
                      [label]="field.label || field.name"
                      [value]="readOnlyValueFor(field, group, i)"
                      class="w-full mb-[20px] adjust-label"
                      />
                  } @else if (isMultiSelect(field) && fieldHasPickList(field)) {
                    <div class="field mb-[14px]">
                      <div class="field-label text-type-11 mb-[6px]">{{ field.label || field.name }}</div>
                      <div class="multi-select-chips">
                        @for (val of row.get(field.name)?.value || []; track trackByValue(0, val)) {
                          <span class="chip">
                            {{ chipLabel(field, val, group, i) }}
                            <mat-icon
                              class="chip-remove"
                              (click)="
                                row.get(field.name)?.setValue((row.get(field.name)?.value || []).filter(v => v !== val))
                              "
                            >close</mat-icon>
                          </span>
                        }
                      </div>
                      <select
                        class="multi-select-add"
                        (change)="
                          row.get(field.name)?.setValue(
                            ((row.get(field.name)?.value || []).includes($any($event.target).value)
                              ? (row.get(field.name)?.value || [])
                              : [...(row.get(field.name)?.value || []), $any($event.target).value])
                          ); $any($event.target).value = ''
                        "
                      >
                        <option value="">Add...</option>
                        @for (opt of (rowPickListOptions[group.key + '-' + i + '-' + field.name] || []); track trackByValue(0, opt.value)) {
                          <option [value]="opt.value">{{ opt.label }}</option>
                        }
                      </select>
                    </div>
                  } @else if (fieldHasPickList(field)) {
                    <app-dropdown
                      [parentFormGroup]="row"
                      [controlName]="field.name"
                      [options]="rowPickListOptions[group.key + '-' + i + '-' + field.name] || []"
                      [enableSearch]="true"
                      [label]="field.label || field.name"
                      class="w-full mb-[20px]"
                    />
                  } @else if (isDate(field)) {
                    <app-date-picker
                      [parentFormGroup]="row"
                      [controlName]="field.name"
                      [label]="field.label || field.name"
                      class="w-full mb-[20px]"
                    />
                  } @else {
                    <app-text-input
                      [parentFormGroup]="row"
                      [controlName]="field.name"
                      [label]="field.label || field.name"
                      [maxLength]="500"
                      class="w-full mb-[20px]"
                    />
                  }
                }
              </div>
            }
            @if (!readOnly) {
              <div class="add-item text-type-9 cursor-pointer flex justify-start items-center mb-[10px]">
                <span
                  (click)="addRow(group.key, group.fields)"
                  [attr.data-testid]="'sample-add-' + group.key"
                  class="flex justify-start items-center"
                  >
                  <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
                  {{ addRowLabel(group) }}
                </span>
              </div>
            }
          </div>
        } @else {
          <div class="flat-fields">
            @if (group.key === 'general') {
              @for (sub of generalSubsections(group); track sub.key) {
                <div class="subsection-accordion" [class.is-expanded]="isSubsectionExpanded(sub.key)">
                  <div (click)="toggleSubsection(sub.key)" class="subsection-header flex justify-between items-center cursor-pointer">
                    <div class="subsection-title text-type-8">{{ sub.label | sentenceCase }}</div>
                    <mat-icon
                      [svgIcon]="isSubsectionExpanded(sub.key) ? 'chevron-up' : 'chevron-down'"
                      class="chevron-icon"
                    />
                  </div>
                  <div class="subsection-content">
                    @for (field of sub.fields; track trackByName(0, field)) {
                      <ng-container *ngTemplateOutlet="fieldRenderer; context: { $implicit: field }" />
                    }
                    <!-- Material picker — only on the context sub-section. The
                         display-only material_code field above shows the name;
                         this dropdown lets users pick / change the material_id. -->
                    @if (sub.key === 'general-context') {
                      @if (readOnly) {
                        <app-view-field
                          [value]="materialDisplayName()"
                          class="w-full mb-[30px] adjust-label"
                          data-testid="sample-value-material"
                          label="Material"
                          />
                      } @else {
                        <app-dropdown
                          [parentFormGroup]="form"
                          controlName="material_id"
                          [options]="materialOptions"
                          [enableSearch]="true"
                          label="Material"
                          class="w-full mb-[20px]"
                        />
                      }
                    }
                  </div>
                </div>
              }
            } @else {
              @for (field of group.fields; track trackByName(0, field)) {
                @if (!isLocationSectionField(field)) {
                  <ng-container *ngTemplateOutlet="fieldRenderer; context: { $implicit: field }" />
                }
              }
            }

            <ng-template #fieldRenderer let-field>
              @if (readOnly && field.name === 'material_test_ids') {
                <div class="field-row mb-[10px]">
                  <div class="field-label">{{ field.label || field.name }}</div>
                  @if (!(form.get(field.name)?.value || []).length) {
                    <div class="field-value text-type-8">-</div>
                  }
                </div>
                <div class="selected-tests mb-[30px]">
                  @for (val of form.get(field.name)?.value || []; track trackByValue(0, val)) {
                    <div (click)="openTestEntry(val)" class="test-row cursor-pointer flex flex-row justify-between items-center">
                      <div class="test-name text-type-11">{{ chipLabel(field, val) }}</div>
                      <mat-icon class="chevron-icon" svgIcon="chevron-right" />
                    </div>
                  }
                </div>
              } @else if (readOnly) {
                <app-view-field
                  [attr.data-testid]="'sample-value-' + field.name"
                  [label]="field.label || field.name"
                  [value]="readOnlyValueFor(field)"
                  class="w-full mb-[30px] adjust-label"
                  />
              } @else if (isDisplayOnly(field)) {
                <app-view-field
                  [attr.data-testid]="'sample-value-' + field.name"
                  [label]="field.label || field.name"
                  [value]="displayValueFor(field)"
                  class="w-full mb-[30px] adjust-label"
                  />
              } @else if (isMultiSelect(field) && fieldHasPickList(field)) {
                <app-multi-select-dropdown
                  [parentFormGroup]="form"
                  [controlName]="field.name"
                  [options]="pickListOptions[field.name] || []"
                  [enableSearch]="true"
                  [enableSelectAll]="false"
                  [label]="field.label || field.name"
                  class="w-full mb-[20px]"
                />
                @if (field.name === 'material_test_ids') {
                  <div class="selected-tests mb-[20px]">
                    @for (val of form.get(field.name)?.value || []; track trackByValue(0, val)) {
                      <div (click)="openTestEntry(val)" class="test-row cursor-pointer flex flex-row justify-between items-center">
                        <div class="test-name text-type-11">{{ chipLabel(field, val) }}</div>
                        <mat-icon class="chevron-icon" svgIcon="chevron-right" />
                      </div>
                    }
                  </div>
                }
              } @else if (fieldHasPickList(field)) {
                <app-dropdown
                  [parentFormGroup]="form"
                  [controlName]="field.name"
                  [options]="pickListOptions[field.name] || []"
                  [enableSearch]="true"
                  [label]="field.label || field.name"
                  class="w-full mb-[20px]"
                />
              } @else if (isDate(field)) {
                <app-date-picker
                  [parentFormGroup]="form"
                  [controlName]="field.name"
                  [label]="field.label || field.name"
                  class="w-full mb-[20px]"
                />
              } @else if (isLatLngField(field)) {
                <app-text-input
                  [parentFormGroup]="form"
                  [controlName]="field.name"
                  [label]="field.label || field.name"
                  [maxLength]="32"
                  class="w-full mb-[20px]"
                />
              } @else if (isMultiline(field)) {
                <app-text-area
                  [parentFormGroup]="form"
                  [controlName]="field.name"
                  [label]="field.label || field.name"
                  class="w-full mb-[20px]"
                />
              } @else {
                <app-text-input
                  [parentFormGroup]="form"
                  [controlName]="field.name"
                  [label]="field.label || field.name"
                  [maxLength]="500"
                  class="w-full mb-[20px]"
                />
              }
            </ng-template>

            <!--
              Location/station — collapsed into a single prompt that opens
              a popup with all 7 fields (mirrors the bid-item station popup
              and the mobile FormFieldPromptView pattern).
            -->
            @if (group.key === 'general') {
              <div class="location-section mb-[30px]">
                <div class="label mb-[8px]">Location / station</div>
                @if (readOnly && !hasLocationValue()) {
                  <div class="field-value text-type-8" data-testid="sample-value-location">-</div>
                } @else if (!hasLocationValue()) {
                  <div (click)="openLocationPopup(group)" class="location-prompt flex flex-row items-center cursor-pointer">
                    <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
                    Add location or station
                  </div>
                } @else {
                  <div
                    (click)="openLocationPopup(group)"
                    [class.cursor-pointer]="!readOnly"
                    class="location-card"
                    data-testid="sample-value-location"
                    >
                    <div class="location-summary text-type-11">{{ locationSummary() }}</div>
                    @if (form?.get('latitude')?.value && form?.get('longitude')?.value) {
                      <div class="location-preview mt-[10px]">
                        <app-location-picker
                          [latitude]="form.get('latitude')?.value"
                          [longitude]="form.get('longitude')?.value"
                          [readOnly]="true"
                          [isDialog]="false"
                          height="120px"
                        />
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        </div><!-- /group-content -->
      </div>
    }

    <!-- Attachments — rendered inline above the action bar, only when there
         are pictures attached. The paperclip add-button in the action bar
         is what triggers uploads. -->
    @if (pictures?.length) {
      <app-pictures-section-with-tags
        (onDelete)="removePicture($event)"
        [isEditable]="!readOnly && !saving && !pushing"
        [pictures]="pictures"
        class="pictures-section mt-[24px] mb-[24px]"
        label="ATTACHMENTS:"
      />
    }

    @if (errorMessage) {
      <div class="error-message text-type-11 mb-[14px]">{{ errorMessage }}</div>
    }
  </div>

  @if (!readOnly) {
  <div class="action-section mb-[5px] flex flex-row gap-[20px] w-full">
    <div [matMenuTriggerFor]="addMenu" class="action-button add-button">
      <mat-icon class="add" svgIcon="plus" />
    </div>
    <app-secondary-button
      (handleClick)="save()"
      [isDisabled]="saving || pushing"
      [isLoading]="saving"
      class="flex-1"
    >
      Save
    </app-secondary-button>
    <app-primary-button
      (handleClick)="push()"
      [isDisabled]="!(record?.uuid || data?.uuid) || pushing || saving"
      [isLoading]="pushing"
      class="flex-1"
    >
      Submit
    </app-primary-button>
  </div>
  }

  <mat-menu #addMenu="matMenu">
    @for (option of addMenuOptions; track option) {
      <button (click)="option.handler()" mat-menu-item>
        <div class="add-menu-item flex justify-start items-center">
          <div class="flex justify-center items-center h-[48px]">
            <mat-icon [svgIcon]="option.icon" class="menu-icon" />
          </div>
          <div class="ml-[12px]">{{ option.label }}</div>
        </div>
      </button>
    }
  </mat-menu>
</div>
